module.exports = __webpack_public_path__ + "static/media/fig.60da7265.png";